export default "__VITE_ASSET__B6G06Zak__"